import useDarkMode from 'use-dark-mode';

import { theme } from '@swf/poker';

const useThemeMode = () => {
  const darkMode = useDarkMode(true);

  return { darkMode, theme };
};

export default useThemeMode;
